/* Iceman 2026 動態（老闆 2026-10-07 從示意頁選了兩種，只加動態、不改排版）
   ① 滑到才浮上來：區塊標題、商品卡、橫滑卡片、大圖（大圖是從微微放大慢慢縮回）。每個只播一次，播完就把 class 拿掉、回到原本的樣子
      哪些頁面：首頁、系列頁、商品頁下半部（比寬度、細節，上面的照片／價格／加入購物車不動）、關於我們／尺寸指南／常見問題／配送／退換貨、廣告落地頁；購物車頁不加
   ③ 大字亮起：大橫幅（首頁滿鑽狂潮）有勾「一個字一個字亮起」時，標題和說明跟著滑動一個字一個字亮起來，往回滑會暗回去
   不作用：手機開「減少動態效果」、佈景主題編輯器裡、瀏覽器太舊。打開網頁時已經在畫面裡的不會藏起來，只有下面還沒看到的才等滑到。
   樣式在 icm-layout.css（.icm-rv／.icm-rv-g／.icm-rv-z／.icm-gl） */
(function () {
  if (window.__icmMotion) return;
  window.__icmMotion = 1;
  if (!('IntersectionObserver' in window) || !window.requestAnimationFrame || !Array.from) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var ONE = '.icm-hsec__head, .icm-prods__grid > .icm-pc, [data-icm-grid] > .icm-pc, .icm-feat__over, .icm-feat__head, .icm-feat__btnwrap, ' +
            '.icm-promo__in, .icm-mem__card, .icm-ban__text:not([data-glow]), ' +                                     // 首頁、系列頁
            '.icm-sec__head, ' +                                                                                       // 商品頁下半部的標題
            '.icm-pg__sec, .icm-ab__row, .icm-ab__contact, .icm-sg__help, .icm-pg__help, ' +                          // 關於我們、尺寸指南、常見問題、配送、退換貨
            '.icm-lpd-sec, .icm-lpe-sec, .icm-lpg-sec, .icm-lpa-tiers, .icm-lpf-rule, .icm-lpf-mem, .icm-lpb-step, .icm-lpc-look, ' +
            '.icm-lpe-reviews, .icm-lpe-launch, .icm-lpe-trust, .icm-lpg-partner, .icm-lpg-rules, .icm-lpg-stats, .icm-lp-faq, .icm-lp-cta__box';   // 落地頁
  var GROUP = '.icm-feat__rail, .icm-dets__rail, .icm-gal2__rail, .icm-mem__icons, .icm-rail, .icm-lpa-grid, .icm-lpf-cats';   // 一整排：裡面一張接一張
  var ZOOM = '.icm-feat__img, .icm-ban__img';                                              // 大圖：慢慢縮回原尺寸
  var STEP = 90, MAX = 5, DONE = 1800;

  function below(el) { var r = el.getBoundingClientRect(); return r.height > 0 && r.top > window.innerHeight; }

  function reveal(hits) {
    hits.sort(function (a, b) { var x = a.getBoundingClientRect(), y = b.getBoundingClientRect(); return (x.top - y.top) || (x.left - y.left); });
    hits.forEach(function (el, i) {                    // 同時進畫面的（例如同一排兩張卡）一張晚 90ms
      var d = Math.min(i, MAX) * STEP;
      io.unobserve(el);
      el.style.setProperty('--rv-d', d + 'ms');
      el.classList.add('is-in');
      setTimeout(function () {
        el.classList.remove('icm-rv', 'icm-rv-g', 'icm-rv-z', 'is-in');
        el.style.removeProperty('--rv-d');
        [].forEach.call(el.children, function (c) { c.style.removeProperty('--rv-i'); });
      }, DONE + d + MAX * STEP);
    });
  }
  var io = new IntersectionObserver(function (list) {
    reveal(list.filter(function (e) { return e.isIntersecting; }).map(function (e) { return e.target; }));
  }, { rootMargin: '0px 0px -10% 0px' });
  // 保險：每秒看一次，已經在畫面裡卻還沒出現的（例如系列頁「看更多」、排序搬動了卡片）直接出現；全部出現過就停
  var safety = setInterval(function () {
    var left = document.querySelectorAll('.icm-rv:not(.is-in), .icm-rv-g:not(.is-in), .icm-rv-z:not(.is-in)'), vh = window.innerHeight, hits = [];
    if (!left.length) { clearInterval(safety); return; }
    [].forEach.call(left, function (el) { var r = el.getBoundingClientRect(); if (r.height && r.top < vh * 0.9 && r.bottom > 0) hits.push(el); });
    if (hits.length) reveal(hits);
  }, 1000);

  function arm(sel, cls) {
    [].forEach.call(document.querySelectorAll(sel), function (el) {
      if (!below(el)) return;                            // 已經看得到的不動
      if (el.parentElement && el.parentElement.closest('.icm-rv, .icm-rv-g')) return;   // 外面那層已經會浮上來，裡面不重複
      el.classList.add(cls);
      if (cls === 'icm-rv-g') [].forEach.call(el.children, function (c, i) { c.style.setProperty('--rv-i', Math.min(i, MAX)); });
      io.observe(el);
    });
  }

  function glow(box) {
    var parts = [].slice.call(box.querySelectorAll('.icm-ban__t, .icm-ban__s')), chars = [];
    if (!parts.length) return;
    parts.forEach(function (p) {
      var s = p.textContent.trim();
      p.textContent = '';
      Array.from(s).forEach(function (ch) {
        var sp = document.createElement('span');
        sp.className = 'icm-gl'; sp.textContent = ch;
        p.appendChild(sp); chars.push(sp);
      });
    });
    var near = false, ticking = false;
    function draw() {                                    // 文字頂端在畫面 85% 開始亮，文字底部到畫面 45% 全亮
      ticking = false;
      var a = parts[0].getBoundingClientRect(), b = parts[parts.length - 1].getBoundingClientRect(), vh = window.innerHeight;
      var p = (vh * 0.85 - a.top) / (vh * 0.4 + (b.bottom - a.top));
      var n = Math.round(Math.max(0, Math.min(1, p)) * chars.length);
      for (var i = 0; i < chars.length; i++) chars[i].classList.toggle('on', i < n);
    }
    new IntersectionObserver(function (l) { near = l[0].isIntersecting; if (near) draw(); }, { rootMargin: '25% 0px' }).observe(box);
    window.addEventListener('scroll', function () { if (near && !ticking) { ticking = true; requestAnimationFrame(draw); } }, { passive: true });
    window.addEventListener('resize', draw);
    draw();
  }

  function init() {
    arm(ONE, 'icm-rv');
    arm(GROUP, 'icm-rv-g');
    arm(ZOOM, 'icm-rv-z');
    [].forEach.call(document.querySelectorAll('[data-glow]'), glow);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
